'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["className", "align", "decoration", "casing"];
/**
 * Feedback
 *
 * React component used to render feedback text. Renders a `span` by default.
 */
var Feedback = react.forwardRef(function (props, ref) {
  var styles = react.useStyleConfig('Feedback', props);
  var _omitThemingProps = react.omitThemingProps(props);
  _omitThemingProps.className;
  _omitThemingProps.align;
  _omitThemingProps.decoration;
  _omitThemingProps.casing;
  var rest = _objectWithoutProperties__default["default"](_omitThemingProps, _excluded);
  var field = react.useFormControlContext();
  var aliasedProps = utils.filterUndefined({
    textAlign: props.align,
    textDecoration: props.decoration,
    textTransform: props.casing
  });
  if (field && !(field !== null && field !== void 0 && field.isInvalid)) return null;
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.span, _extends__default["default"]({
    ref: ref
  }, field === null || field === void 0 ? void 0 : field.getErrorMessageProps(rest, ref), {
    className: utils.cx('chakra-feedback', props.className)
  }, aliasedProps, rest, {
    __css: styles
  }));
});
Feedback.displayName = 'Feedback';
exports.Feedback = Feedback;